import { Delete } from './Delete'
import { Get } from './Get'
import { Post } from './Post'
import { Put } from './Put'
import { ApiHelpers, APIHosts } from './ApiHelpers'

export interface GroupInfo {
  id?: string
  code: string
  name: string
  status: number
  note: string
  organizationId: string
}

class GroupServiceController extends ApiHelpers {
  ApiHost = APIHosts.LicenseManager

  public Put = {
    updateGroupInfo: (id: string, data: Partial<GroupInfo>[]) => {
      const baseUrl = this.getHost(this.ApiHost)
      const url = `${baseUrl}/organizationJobs`
      return Put(url, data)
    },
    assignGroupToStaff: (
      jobid: string,
      organizationId: string,
      userId: string,
    ) => {
      const baseUrl = this.getHost(this.ApiHost)
      const url = `${baseUrl}/organizationJobs/${jobid}/assign-user`
      return Put(url, { organizationId, userId })
    },
  }

  public Get = {
    getListGroups: async () => {
      const baseUrl = this.getHost(this.ApiHost)
      let url = `${baseUrl}/organizationJobs`
      return Get(url)
    },
    searchListGroups: async (orgId: string, data: any) => {
      const baseUrl = this.getHost(this.ApiHost)
      let url = `${baseUrl}/organizationJobs/organization/${orgId}`
      const filterData = {
        params: {
          ...data,
        },
      }
      return Get(url, filterData)
    },
    getListGroupsByOrgId: async (
      orgId: string,
      name?: string,
      status?: number,
    ) => {
      const baseUrl = this.getHost(this.ApiHost)
      let url = `${baseUrl}/organizationJobs/organization/${orgId}`
      const params: any = {}
      if (name !== undefined && name !== '') {
        params.name = name
      }
      if (status !== undefined) {
        params.status = status
      }

      return Get(url, Object.keys(params).length > 0 ? { params } : undefined)
    },
    exportAllGroups: (orgId: string, jobIds?: string[]) => {
      const baseUrl = this.getHost(this.ApiHost)
      const query = new URLSearchParams()
      query.append('organizationId', orgId)
      jobIds?.forEach(id => query.append('jobIds', id))
      return Get(`${baseUrl}/organizationJobs/export?${query.toString()}`, {
        responseType: 'blob',
      })
    },
    exportCurrentPage: (organizationId: string, data: any) => {
      const baseUrl = this.getHost(this.ApiHost)
      return Get(`${baseUrl}/organizationJobs/exportcurrentpage`, {
        params: {
          organizationId,
          ...data,
        },
        responseType: 'blob',
      })
    },
  }

  public Post = {
    createNewGroup: (data: GroupInfo) => {
      const baseUrl = this.getHost(this.ApiHost)
      return Post(`${baseUrl}/organizationJobs`, data)
    },
    importGroups: (orgId: string, file: File) => {
      const baseUrl = this.getHost(this.ApiHost)
      const formData = new FormData()
      formData.append('organizationId', orgId)
      formData.append('file', file)
      return Post(`${baseUrl}/organizationJobs/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
  }

  public Delete = {
    removeGroups: (orgId: string, groupIds: string[]) => {
      const baseUrl = this.getHost(this.ApiHost)
      const url = `${baseUrl}/organizationJobs?organizationId=${orgId}`
      return Delete(url, groupIds)
    },
    removeGroupById: (id: string, orgId: string) => {
      const baseUrl = this.getHost(this.ApiHost)
      const url = `${baseUrl}/organizationJobs/${id}`
      return Delete(url, {
        params: {
          id,
        },
      })
    },
  }
}

export const GroupServices = new GroupServiceController()
